import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { environment } from 'src/environments/environment'
import { HttpHelperService } from '../http.service'
import { OrderLineExtraDto } from 'src/app/types/dto/order-line-extra.dto'
import { TimedCache } from '../timed-cache'
import { map, switchMap } from 'rxjs/operators'
import { ProcessedExtra } from 'src/app/types/datasources/extras.model'
import { JobLookupApiService } from './job-lookup.api.service'
import { AuthService } from '../auth.service'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class ExtrasApiService {
  private http = inject(HttpClient);
  private httpHelper = inject(HttpHelperService);
  private jobLookup = inject(JobLookupApiService);
  private auth = inject(AuthService);
  private logger = inject(LogService);

  baseURL = environment.apiUrl + 'order-line-extras/'
  private cachedExtras = new TimedCache<ProcessedExtra[]>()

  getExtras() {
    const comp = this.auth.getCurrentCompany()
    if (!comp) {
      this.logger.log('extras.api', 'getExtras', null, 'no company')
      throw Error('no company set in getExtras')
    }

    return this.cachedExtras.get(comp.id, () => {
      return this.http.get<OrderLineExtraDto[]>(this.baseURL, this.httpHelper.httpReadOnlyOptions).pipe(
        map((res) =>
          res.map((e) => ({
            ...e,
            createDate: new Date(e.createDate),
            modifiedDate: new Date(e.modifiedDate),
          }))
        ),
        switchMap((extras) => this.jobLookup.enrich(extras))
      )
    })
  }
}
